export default __webpack_public_path__ + "static/media/ic-unique-key-description.8b1bd15e.svg";